export const adminCreateJob = `mutation adminCreateJob($input: JobCreateInput!) {
  adminCreateJob(input: $input) {
    jobId
    active
    description
  }
}`;

export const adminUpdateJob = `mutation adminUpdateJob($input: JobUpdateInput!) {
  adminUpdateJob(input: $input) {
    jobId
    active
    description
  }
}`;

export const adminDeleteJob = `mutation adminDeleteJob($jobId: ID!) {
  adminDeleteJob(jobId: $jobId) {
      jobId
  }
}`;
